import { IResourceComponentsProps, useShow } from "@pankod/refine-core";

export const CustomPage: React.FC<IResourceComponentsProps> = () => {
  return (
    <div>
      Hello custom page.
    </div>
  );
};
